import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelWebhookConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelWebhookConfigEntity
